import { render } from "./Electronics Research Center.vue?vue&type=template&id=053db18a&scoped=true"
const script = {}

import "./Electronics Research Center.vue?vue&type=style&index=0&id=053db18a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-053db18a"

export default script